export class Ids {
  public id: number;

  constructor(id: number) {
    this.id = id;
  }
}
